const initialState = {
  list: [],
  fetching: false,
  fetchingMore: false,
  canFetchMore: true,
  fetched: false,
  error: null,
  loading: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'CONVERSATIONS_FETCH_PENDING': {
      return {
        ...state,
        fetching: true,
      }
    }

    case 'CONVERSATIONS_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        error: true,
      }
    }
    case 'CONVERSATIONS_FETCH_FAILURE': {
      return {
        ...state,
        fetching: false,
        error: true,
      }
    }

    case 'CONVERSATIONS_FETCH_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        list: action.payload.data,
      }
    }

    case 'CONVERSATIONS_FETCH_MORE_PENDING':
      return {
        ...state,
        fetchingMore: true,
      }

    case 'CONVERSATIONS_FETCH_MORE_REJECTED':
      return {
        ...state,
        fetchingMore: false,
      }

    case 'CONVERSATIONS_FETCH_MORE_FULFILLED':
      return {
        ...state,
        fetchingMore: false,
        list: state.list.concat(action.payload.data),
      }

    case 'CONVERSATIONS_FETCH_MORE_STOP':
      return {
        ...state,
        canFetchMore: false,
      }

    default: {
      return state
    }
  }
}
